<div class="max-h-96 overflow-auto">
  <table
    class="min-w-full w-max table-fixed border-separate border-spacing-0 text-sm text-left rtl:text-right text-gray-500"
  >
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0 z-10">
      <tr>
        <th scope="col" class="w-64 align-top px-4 py-3">SW-Partnumber</th>
        @for (dtcFriendlyNumber of uniqueDtcFriendlyNumbers; track $index) {
          <th scope="col" class="w-40 align-top px-4 py-3">
            <label class="flex min-w-0 items-start gap-2">
              <input
                (change)="onCheckboxChangeForColumn($event, dtcFriendlyNumber)"
                type="checkbox"
                [checked]="isColumnChecked(dtcFriendlyNumber)"
                class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-200"
              />
              <span class="whitespace-normal break-words">{{ dtcFriendlyNumber }}</span>
            </label>
          </th>
        }
      </tr>
    </thead>
    <tbody>
      @if (orderedUpdateInfos.length === 0 || uniqueDtcFriendlyNumbers.length === 0) {
        <tr>
          <td
            class="px-6 py-4 text-center font-medium text-amazone-orange align-top"
            [attr.colspan]="uniqueDtcFriendlyNumbers.length + 1"
          >
            No linked DTC changes in other versions
          </td>
        </tr>
      }
      @for (
        updateInfo of linkedDtcsUpdateInfo;
        track updateInfo.errorMessageId + '-' + updateInfo.swPartNumberFriendlyNumber
      ) {
        <tr class="bg-white border-b hover:bg-gray-50">
          <td class="px-4 py-4 align-top font-semibold text-gray-700">
            <div class="flex flex-col gap-1">
              <span>{{ getRowLabel(updateInfo) }}</span>
              @if (updateInfo.isEditedEntity) {
                <span class="text-xs font-medium text-amazone-orange">Edited Error Message</span>
              }
            </div>
          </td>
          @for (dtcFriendlyNumber of uniqueDtcFriendlyNumbers; track $index) {
            @let dtcLinkInfo = getDtcLinkInfo(updateInfo, dtcFriendlyNumber);
            <td class="px-4 py-4 align-top">
              @if (
                dtcLinkInfo?.linkState === dtcLinkState.linkCanBeAdded ||
                dtcLinkInfo?.linkState === dtcLinkState.linkCanBeRemoved
              ) {
                @let tooltipId = 'tooltip-dtc-' + $safeNavigationMigration(dtcLinkInfo?.dtcId);
                <label class="flex min-w-0 items-start gap-2 text-xs text-gray-700">
                  <input
                    type="checkbox"
                    (change)="toggleSiblingLinkPropagation(updateInfo, dtcFriendlyNumber)"
                    [checked]="
                      updateInfo.isEditedEntity ||
                      getDtcLinkInfo(updateInfo, dtcFriendlyNumber)?.linkState === dtcLinkState.asigned ||
                      dtcLinkInfo?.selected
                    "
                    [disabled]="isDisabledCell(updateInfo, dtcFriendlyNumber)"
                    [attr.data-tooltip-target]="tooltipId"
                    class="rounded border-gray-300 text-amazone-orange focus:ring-amazone-orange disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:border-gray-200"
                  />
                  <span class="inline-flex rounded-md text-xs font-semibold" [attr.data-tooltip-target]="tooltipId">
                    {{ getLabel(dtcLinkInfo, $safeNavigationMigration(updateInfo?.isEditedEntity)) }}
                  </span>
                </label>
                <div
                  id="{{ tooltipId }}"
                  role="tooltip"
                  class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-amber-600 rounded-lg shadow-xs opacity-0 tooltip"
                >
                  {{ getTooltipText(dtcLinkInfo) }}
                  <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
              } @else {
                <label class="opacity-60 flex min-w-0 items-start gap-2 text-xs text-gray-700">
                  <span class="inline-flex rounded-md text-xs font-semibold" title="FooBar">
                    {{ getLabel(dtcLinkInfo, $safeNavigationMigration(updateInfo?.isEditedEntity)) }}
                  </span>
                </label>
              }
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
